import { apiRequest } from '@/core';
import { type User } from '@/types';

export const verifyUserRequest = async () =>
  apiRequest<User>({
    endpoint: 'verify',
  });
